<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Partner Enrollments</h4>
            </div>
             <div v-if="error">{{error}}</div>
          <el-date-picker
          width="250px"
      v-model="daterange"
      type="daterange"
      align="right"
    format="yyyy-MM-dd"
          
      value-format="yyyy-MM-dd"
 
     
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      :picker-options="pickerOptions">
    </el-date-picker>
    <br />
                   {{daterange}}
            <div class="table-responsive">
              <ApolloQuery
              clientId="partnerClient"
                :query="require('./customerListAdmin.gql')"
                :variables="{start:daterange[0],end:daterange[1]}"
                fetchPolicy="no-cache"
              >
                <template slot-scope="{ result: { data, loading } }">
                  <el-button @click="createCSV(data.Enrollments)">Download Csv</el-button>
                  <div v-if="loading">Loading...</div> 
                  
                  <data-tables-server
                    v-else-if="data"
                    class="table-shopping"
                    style="width: 100%"
                    :data="data.Enrollments"
                    :tool-bar="false"
                    :current-page="1"
                    :total="data.Enrollments.length"
                    :loading="loading"
                    :page-size="20"
                    :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
                  >
                    
                       <el-table-column label="Name" min-width="40" >
                         <template slot-scope="props">
                         {{props.row.customer.firstname}} {{props.row.customer.lastname}}
                         </template>
                       </el-table-column>
                
                       <el-table-column label="Email" min-width="60" >
                                <template slot-scope="props">
                         {{props.row.customer.email}}
                         </template>
                       </el-table-column>
                    <el-table-column label="Enrollments" min-width="100">
                      <template slot-scope="props">
                        {{props.row.product.name}}
                      </template>
                    </el-table-column>
                    <el-table-column label="Enrol Date" width="120">
                      
                      <template slot-scope="props"> 
                       {{props.row.created_at | moment('DD-MM-YYYY')}}
                        </template>
                         </el-table-column>
                       <el-table-column label="Partner" width="120">
                      
                      <template slot-scope="props"> 
                       {{props.row.customer.partner.name}}
                        </template>
                         </el-table-column>
                    
                  </data-tables-server>
                  <div v-else class="no-result apollo">No result :(</div>
                </template>
              </ApolloQuery>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import moment from "moment";
export default {
   apollo: {
    $client: 'partnerClient'
  },
  data() {
    return {
      pickerOptions: {
          shortcuts: [ {
            text: 'Last month',
            onClick(picker) {

              picker.$emit('pick', [moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]);
            }
          }]
        },

      dialogVisible: false,
      loading:false,
       error: null,
       daterange:[moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
    };
  },
  methods:{
      createCSV(data){
        let csvArr = [];
         var sLen = data.length;
           for (var i = 0; i < sLen; i++) {
     csvArr.push([
          data[i].customer.firstname+" "+data[i].customer.lastname,
          data[i].customer.email,
          data[i].product.name,  
          moment(data[i].created_at).format('YYYY-MM-DD'),
		  data[i].customer.partner.name
        ]);
      }
console.log(data)
 let csvContent =
        [
          [
           "Student",
           "Email",
           "Course",
           "Enrollment Date",
		   "Partner"
          ]
        ] + "\r";

      csvArr.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });

      var fileURL = window.URL.createObjectURL(
        new Blob([csvContent], { type: "text/csv" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Partner_Enrollments-"+moment().format('MMMM-YYYY')+".csv");
      document.body.appendChild(fileLink);
      fileLink.click();



      }
  }
};
</script>
<style>
.el-date-editor .el-range-separator {
 width: 8% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/Partners.vue